// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__xgVcI","header":"Header_header__IahnL","container":"Header_container__QQXNs"};